import {html, LitElement} from "lit";

export class WeekPage extends LitElement {
    constructor() {
        super();
    }

    render() {
        return html`<div class="container"><h2>I am week</h2></div>`
    }

    createRenderRoot() {
        return this;
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);

        let job = this.doSomething();

        let event = new CustomEvent('pending-state', {
            composed: true,
            bubbles: true,
            detail: {promise: job}
        });

        this.dispatchEvent(event);

    }

    async doSomething() {
        return new Promise(resolve => setTimeout(resolve, 2000));
    }
}

customElements.define('x-week-page', WeekPage);